import React__default from 'react';
import { EditUserProfileProvider } from './EditUserProfile/context.js';
import { EditUserProfileUI } from './EditUserProfile/components/EditUserProfileUI.js';
import './chunks/bundle-BXYHgzRj.js';
import './useSendbirdStateContext.js';
import './withSendbird.js';
import './chunks/bundle-DWyboFhb.js';
import './chunks/bundle-CqMQE3-R.js';
import './chunks/bundle-b7Foa0HG.js';
import './chunks/bundle-Bd7J49Pj.js';
import './chunks/bundle-CGbKAqtd.js';
import '@sendbird/chat/groupChannel';
import './utils/message/getOutgoingMessageState.js';
import './chunks/bundle-CXA05pe2.js';
import './chunks/bundle-DokyceKk.js';
import './chunks/bundle-Dz4_R08c.js';
import './chunks/bundle-u-vzK-oc.js';
import 'react-dom';
import './chunks/bundle-DtujCCHB.js';
import './ui/IconButton.js';
import './ui/Button.js';
import './chunks/bundle-DNnUvjnZ.js';
import './ui/Icon.js';
import '@sendbird/uikit-tools';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import './chunks/bundle-ClfkSu0m.js';
import '@sendbird/chat/openChannel';
import './chunks/bundle-C4eUm39A.js';
import './chunks/bundle-CZybJwCN.js';
import './ui/SortByRow.js';
import './ui/Input.js';
import './chunks/bundle-DGC3rWK4.js';
import './ui/ImageRenderer.js';
import './chunks/bundle-Dwpc_MJZ.js';
import './ui/TextButton.js';
import './chunks/bundle-DmX77DTu.js';

var EditUserProfile = function (props) {
    var onEditProfile = props.onEditProfile, onCancel = props.onCancel, onThemeChange = props.onThemeChange;
    return (React__default.createElement(EditUserProfileProvider, { onEditProfile: onEditProfile, onCancel: onCancel, onThemeChange: onThemeChange },
        React__default.createElement(EditUserProfileUI, null)));
};

export { EditUserProfile as default };
//# sourceMappingURL=EditUserProfile.js.map
